import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import NotSection from './components/NotSection';
import HowItWorksSection from './components/HowItWorksSection';
import ForTherapistsSection from './components/ForTherapistsSection';
import ForSpaSection from './components/ForSpaSection';
import SecuritySection from './components/SecuritySection';
import CreditModelSection from './components/CreditModelSection';
import MobileSection from './components/MobileSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-off-white font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <NotSection />
        <HowItWorksSection />
        <ForTherapistsSection />
        <ForSpaSection />
        <SecuritySection />
        <CreditModelSection />
        <MobileSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}